var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.1-User-Management_04",
    transform: "translate(-1543.000000, -743.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-Up-Actions-Copy-2",
    transform: "translate(1530.000000, 677.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(10.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,30.25 L3,34 L6.75,34 L17.81,22.94 L14.06,19.19 L3,30.25 Z M20.71,20.04 C21.1,19.65 21.1,19.02 20.71,18.63 L18.37,16.29 C17.98,15.9 17.35,15.9 16.96,16.29 L15.13,18.12 L18.88,21.87 L20.71,20.04 Z",
    id: "Edit"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.9aa2bc18e8e6651a83653753a7743ca8.svg";
export { ForwardRef as ReactComponent };